// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"254":"5fb2fc1a","453":"8ab44547","536":"07d128f9"}[chunkId] + ".chunk.js";
};